import gql from 'graphql-tag';

const deleteVideoQuery = gql`
  mutation deleteVideo($videoId: String!) {
    deleteVideo(videoId: $videoId)
  }
`;

const deleteVideo = {
  mutation: deleteVideoQuery,
  module: 'video',
  buildVariables: (videoId: string) => ({ videoId })
} as const;

export default deleteVideo;
